var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54423 0.402725C7.68769 -0.0387924 8.31231 -0.0387932 8.45577 0.402725L9.91303 4.88771C9.97719 5.08516 10.1612 5.21885 10.3688 5.21885H15.0846C15.5488 5.21885 15.7419 5.81291 15.3663 6.08578L11.5511 8.85765C11.3832 8.97968 11.3129 9.19599 11.377 9.39344L12.8343 13.8784C12.9778 14.3199 12.4724 14.6871 12.0968 14.4142L8.28168 11.6423C8.11372 11.5203 7.88628 11.5203 7.71832 11.6423L3.90316 14.4142C3.52758 14.6871 3.02225 14.3199 3.16571 13.8784L4.62296 9.39344C4.68712 9.19599 4.61684 8.97968 4.44888 8.85765L0.633721 6.08578C0.258144 5.81291 0.451164 5.21885 0.915404 5.21885H5.63119C5.83881 5.21885 6.02281 5.08516 6.08697 4.88771L7.54423 0.402725Z",
    fill: "#DE6139"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOn);
export default __webpack_public_path__ + "static/media/star-on.57ac9ef8.svg";
export { ForwardRef as ReactComponent };